import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { UKAdmissionDayPage } from "@modules/study/webinar/uk_admission_day";

const UkAdmissionDay = () => {
  return (
    <LayoutMain
      title={`UK Admission Day`}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/uk-admission-day`}
    >
      <UKAdmissionDayPage />
    </LayoutMain>
  );
};

export default UkAdmissionDay;
